module.exports = __webpack_public_path__ + "fonts/GoblinOne.db8327e6.ttf";